import React, { useEffect, useRef } from 'react'
import './style.scss'

import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

import ReactModal from 'react-modal'
ReactModal.setAppElement('#root')

const Modal = ({
    children,
    overlayClassName = '',
    className = '',
    isOpen,
    ...rest
}) => {
    const modalRef = useRef()

    useEffect(() => {
        if (isOpen) {
            setTimeout(() => {
                modalRef.current && disableBodyScroll(modalRef.current)
            })
        }

        return () => {
            clearAllBodyScrollLocks()
        }
    }, [isOpen])

    return (
        <ReactModal
            contentRef={ref => (modalRef.current = ref)}
            // contentRef={modalRef}
            overlayClassName={`app-react-modal__overlay ${overlayClassName}`}
            className={`app-react-modal ${className}`}
            isOpen={isOpen}
            {...rest}
        >
            {children}
        </ReactModal>
    )
}

export default Modal
